/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Suggestion_NavigateInputs */



/**
* | output |
* | --- |
* | "Show me around" |
*
* @param {Uno_Suggestion_NavigateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_suggestion_navigate = /** @type {((inputs?: Uno_Suggestion_NavigateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Suggestion_NavigateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeig mir alles")
	return /** @type {LocalizedString} */ ("Show me around")
});